import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_PAYMENT_SUMMARY, GET_PAYMENT_SUMMARY_ERROR, GET_PAYMENT_SUMMARY_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getPaymentSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/client/payment-summary`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PAYMENT_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PAYMENT_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PAYMENT_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetPaymentSummary() {
  yield takeEvery(GET_PAYMENT_SUMMARY, getPaymentSummary);
}

function* getPaymentSummarySaga() {
  yield all([fork(watchGetPaymentSummary)]);
}

export default getPaymentSummarySaga;
